// extracted by mini-css-extract-plugin
module.exports = {"message":"AnswerStatsMessage_message__3i_cU","icon":"AnswerStatsMessage_icon__AJ8l6"};